import {
    faBookOpen,
    faConciergeBell,
    faUser,
    faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tab, Tabs } from "react-bootstrap";
import ListaTodosAtendimentos from "./AtendimentosGeral";

export default function TodosAtendimentos() {
    return (
        <>
            <Tabs>
                <Tab
                    title={
                        <>
                            <FontAwesomeIcon
                                className="mr-2"
                                icon={faBookOpen}
                            />
                            {"Todos Atendimentos"}
                        </>
                    }
                    eventKey={"GERAL"}
                >
                    <ListaTodosAtendimentos atendimento="GERAL" />
                </Tab>
                <Tab
                    title={
                        <>
                            <FontAwesomeIcon
                                className="mr-2"
                                icon={faConciergeBell}
                            />
                            {"Fila de Atendimentos"}
                        </>
                    }
                    eventKey={"GRUPO"}
                >
                    <ListaTodosAtendimentos atendimento="GRUPO" />
                </Tab>
                <Tab
                    title={
                        <>
                            <FontAwesomeIcon className="mr-2" icon={faUser} />
                            {"Atendendo"}
                        </>
                    }
                    eventKey={"USUARIO"}
                >
                    <ListaTodosAtendimentos atendimento="USUARIO" />
                </Tab>
                <Tab
                    title={
                        <>
                            <FontAwesomeIcon
                                className="mr-2"
                                icon={faUserTie}
                            />
                            {"Acompanhando"}
                        </>
                    }
                    eventKey={"ACOMPANHAMENTO"}
                >
                    <ListaTodosAtendimentos atendimento="ACOMPANHAMENTO" />
                </Tab>
            </Tabs>
        </>
    );
}
